import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const organizationPhysicalArchive = createCrudVuexModule({
  namespaced: true,
  path: "/physical-archive",
  actions: {
    async addFromLibrary({ commit }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.post("/physical-archive/add-from-library", payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});
